import { call, put, takeLatest } from 'redux-saga/effects';
import { getTransitionToken } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getInfo(action) {
  const response = yield call(getTransitionToken, action.payload);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* oldTokenSaga() {
  yield takeLatest(actionTypes.GET_INFO, getInfo);
  yield takeLatest(actionTypes.GET_INFO_SKIP_LOADING, getInfo);
}
